import { PageLayout } from '$components/common'
import { RouteObject } from 'react-router-dom'
import { default as PayAdjustments } from './pay-rules'
import { default as Compliance } from '.'

const basePath = '/time/compliance'
export const complianceRoutes: RouteObject[] = [
  {
    path: `${basePath}/pay-rules/add-package`,
    element: (
      <PageLayout title="New Pay Adjustment Package" displayLeftTitle={false}>
        <PayAdjustments.AddPackage.Component />
      </PageLayout>
    ),
    loader: PayAdjustments.AddPackage.Loader,
  },
  {
    path: `${basePath}/pay-rules/setup-package/:packageId`,
    element: (
      <PageLayout title="Setup Pay Adjustment Package" displayLeftTitle={false}>
        <PayAdjustments.SetupPackage.Component />
      </PageLayout>
    ),
    loader: PayAdjustments.SetupPackage.Loader,
  },
  {
    path: `${basePath}/pay-rules/manage/:packageId`,
    element: (
      <PageLayout
        title="Manage Pay Adjustment Package"
        displayLeftTitle={false}
      >
        <PayAdjustments.ManagePackage.Component />
      </PageLayout>
    ),
    loader: PayAdjustments.ManagePackage.Loader,
  },
  {
    path: `${basePath}/pay-rules/create-rule/:packageId`,
    element: (
      <PageLayout
        title="Create New Pay Adjustment Rule"
        displayLeftTitle={false}
      >
        <PayAdjustments.CreateRule.Component />
      </PageLayout>
    ),
    loader: PayAdjustments.CreateRule.Loader,
  },
  {
    path: `${basePath}/pay-rules/view-rule/:packageId/:ruleId`,
    element: (
      <PageLayout title="View Pay Adjustment Rule" displayLeftTitle={false}>
        <PayAdjustments.ViewRule.Component />
      </PageLayout>
    ),
    loader: PayAdjustments.ViewRule.Loader,
  },
  {
    path: `${basePath}/pay-rules/edit-rule/:packageId/:ruleId`,
    element: (
      <PageLayout title="Edit Pay Adjustment Rule" displayLeftTitle={false}>
        <PayAdjustments.EditRule.Component />
      </PageLayout>
    ),
    loader: PayAdjustments.EditRule.Loader,
  },
  {
    path: `${basePath}/pay-rules/copy-rule/:newPackageId/:oldPackageId/:ruleId`,
    element: (
      <PageLayout title="Copy Pay Adjustment Rule" displayLeftTitle={false}>
        <PayAdjustments.CopyRule.Component />
      </PageLayout>
    ),
    loader: PayAdjustments.CopyRule.Loader,
  },
  {
    path: `${basePath}/pay-classifications`,
    element: (
      <PageLayout title={'Pay Classifications'} displayLeftTitle={false}>
        <Compliance.PayClassifications.Component />
      </PageLayout>
    ),
    loader: Compliance.PayClassifications.Loader,
  },
  {
    path: `${basePath}/pay-classifications/manage`,
    element: (
      <PageLayout title={'Add Pay Classification'} displayLeftTitle={false}>
        <Compliance.PayClassifications.Manage.Component />
      </PageLayout>
    ),
    loader: Compliance.PayClassifications.Manage.Loader,
  },
  {
    path: `${basePath}/pay-classifications/add`,
    element: (
      <PageLayout
        title={'Create Custom Pay Classification'}
        displayLeftTitle={false}
      >
        <Compliance.PayClassifications.Add.Component />
      </PageLayout>
    ),
    loader: Compliance.PayClassifications.Add.Loader,
  },
  {
    path: `${basePath}/pay-classifications/:payClassificationId`,
    element: (
      <PageLayout displayLeftTitle={false}>
        <Compliance.PayClassifications.Edit.Component />
      </PageLayout>
    ),
    loader: Compliance.PayClassifications.Edit.Loader,
  },
  {
    path: `${basePath}/leave-types`,
    element: (
      <PageLayout title={'Leave Types'} displayLeftTitle={false}>
        <Compliance.LeaveTypes.Component />
      </PageLayout>
    ),
    loader: Compliance.LeaveTypes.Loader,
  },
  {
    path: `${basePath}/leave-types/manage`,
    element: (
      <PageLayout title={'Add Leave Type'} displayLeftTitle={false}>
        <Compliance.LeaveTypes.Manage.Component />
      </PageLayout>
    ),
    loader: Compliance.LeaveTypes.Manage.Loader,
  },
  {
    path: `${basePath}/leave-types/add`,
    element: (
      <PageLayout title={'Create Leave Type'} displayLeftTitle={false}>
        <Compliance.LeaveTypes.Add.Component />
      </PageLayout>
    ),
    loader: Compliance.LeaveTypes.Add.Loader,
  },
  {
    path: `${basePath}/leave-types/:leaveTypeId`,
    element: (
      <PageLayout>
        <Compliance.LeaveTypes.Edit.Component />
      </PageLayout>
    ),
    loader: Compliance.LeaveTypes.Edit.Loader,
  },
]
